import '@fe-core-ui/src/style/tailwind.css';
import '@fe-core-ui/src/style/theme.css';
import React, { Suspense } from 'react';
import './styles/index.css';

import { TW_ROOT } from '@utils/constants';
import ReactDOM from 'react-dom/client';
import App from './App';

/*!
 * Learnifier fe-learner-catalog
 */

ReactDOM.createRoot(
  document.getElementById('fe-learner-catalog-root') as HTMLElement,
).render(
  <React.StrictMode>
    <Suspense>
      {/* eslint-disable-next-line tailwindcss/no-custom-classname */}
      <div id={TW_ROOT} className="fe-learner-catalog-tw">
        <App />
      </div>
    </Suspense>
  </React.StrictMode>,
);
